import { BadgeVariant } from "shared/components/Badge";
import type { AddressValidationStatus as AddressValidationStatusValue } from "types/landlord/address";

export const STATUS_BADGE: Record<
  AddressValidationStatusValue,
  { variant: BadgeVariant; label: string }
> = {
  verified: { variant: BadgeVariant.SUCCESS, label: "Verified" },
  issue_found: { variant: BadgeVariant.ERROR, label: "Address issue found" },
  pending: { variant: BadgeVariant.BASE, label: "Not yet checked" },
  not_checked: { variant: BadgeVariant.BASE, label: "Not yet checked" }
};
